import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Interweave from 'interweave';
import React from 'react';
import { useTranslation } from 'react-i18next';

const CertificateDetails = () => {
  const classes = useStyles();
  const { t } = useTranslation(['views']);

  return (
    <Box className={classes.root}>
      <Grid container>
        <Grid item xs={12} md={1} />
        <Grid item xs={12} md={2} className={classes.mediaContainer}>
          <img className={classes.media} src="/images/CertificateIcon.png" />
        </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.stepContainer}>
              <Box style={{ marginTop: 35 }} className={classes.textContainer}>
                <Typography
                  className={classes.text}
                  component="span"
                  color="textSecondary"
                >
                  <Interweave
                    content={"Certificado emitido conforme o Decreto nº 5.154/2004, que regulamenta a oferta de cursos de qualificação e capacitação profissional, com respaldo na Lei de Diretrizes e Bases da Educação Nacional (Lei nº 9.394/96, art. 41)."}
                  />
                </Typography>
              </Box>
            </Box>
              </Grid>
        </Grid>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  mediaContainer: {
    marginTop: 25,
    display: 'flex',
    justifyContent: 'center',
  },
  number: {
    fontSize: 17,
    fontWeight: 'bold',
    color: '#069EDB'
  },
  text: {
    fontSize: 17,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  media: {
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    maxWidth: 164,
    maxHeight: 164,
    boxShadow: ('0px 20px 40px 0px #2a2e4329')
  },
  stepContainer: {
    paddingLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(0),
      marginTop: theme.spacing(4),
    },
  },
  textContainer: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      marginTop: theme.spacing(2),
    },
  },
}));

export default CertificateDetails;
